import { render } from "./SplitButton.vue?vue&type=template&id=7366d0e1&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"

import "./SplitButton.vue?vue&type=style&index=0&id=7366d0e1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7366d0e1"]])

export default __exports__